import React, { useState, useEffect } from "react";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import ContentLoader from "react-content-loader";
import AsyncSelect from 'react-select/async';
import MaterialTable from 'material-table'
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { MTableToolbar } from "material-table";
import _ from "lodash";

import { API } from "../../backend";
import ApplyReceiptService from "../../services/receipts/applyGlobalReceipt"
import Helper from "../../Helper";
import { getTrans as t } from "../../Localization/translations"
import authHeader from "../../services/auth-header";
import NotesSingle from "../../components/Notes/NotesSingle";


function ViewRecipts({ customerPermission }) {
	const ReceipttableRef = React.createRef();
	var contractNumber = ""
	var customerName = ""
	const [successful, setSuccessful] = useState(false);
	const [selectedValue, setSelectedValue] = useState(null);
	const [inputvalue, setValue] = useState("");
	const [selectedValue2, setSelectedValue2] = useState(null);
	const [inputvalue2, setValue2] = useState("");
	const [loading, setLoading] = useState(true)
	const [selectedRowId, setSelectedRowId] = useState(null);
	const [state1, setState] = useState({
		isPaneOpen: false,
		isPaneOpenLeft: false,
	});

	const location = useLocation()
	const receiptstatus = location?.state
	const [permissionss, setPermission] = useState(localStorage.getItem('permissions'))
	const permissionsArray = permissionss.split(',');
	const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
	const [object_name, setObject_name] = useState('Receipts')
	const handelInputChange2 = (value1) => {
		setValue2(value1);
	}

	const handelChange2 = (value1) => {
		setSelectedValue2(value1)
	}

	const loadOptions2 = async (inputValue2) => {
		if (inputValue2 !== "") {
			const response = await axios.get(
				API + `contracts/contracts/filter/?id=${inputValue2}`, { headers: authHeader() }
			);
			return response.data.data
		}
	}

	const handelInputChange = (value) => {
		setValue(value);
	}

	const handelChange = (value) => {
		setSelectedValue(value)
	}

	const handleClear = () => {
		setSelectedValue2(null)
		setSelectedValue(null)
		ReceipttableRef.current.onQueryChange();

	}

	const loadOptions = async (inputValue) => {
		if (inputValue !== "") {
			const responseJSON = await axios.get(
				API + `parties/vendor/?party_type=Customer&&customer_name=${inputValue}`, { headers: authHeader() }
			);
			return responseJSON.data.data
		}
	};

	const navigate = useNavigate()

	useEffect(() => {
		setLoading(false)
	}, [successful]);

	const handleView = (id, status) => {
		if (status === "Fully Applied" || status === "Cancelled"  || status === "Reversed") {
			navigate("/receipts/viewreceipts", { state: id })
		}
		else {
			if (customerPermission !== 'Customer') {
				navigate("/receipts/editreceipts", { state: id })
			}
		}
	}

	const handleApplyManually = (state, receipt_amount, applied_amount, contract_id, customer_id) => {
		let receiptamt = 0
		if (contract_id == null) {
			contract_id = customer_id
		}
		else {
			contract_id = contract_id
		}
		receiptamt = receipt_amount - applied_amount
		ApplyReceiptService.applyReceipt(
			state,
			receiptamt,
			applied_amount,
			contract_id,
		).then(
			(response) => {
				if (response.data.success) {
					setSuccessful(true);
					toast.success(`${response.data.response}`, {
						position: "top-right",
						autoClose: 1000,
						hideProgressBar: false,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "light",
					})
				}
				else {
					toast.error(`${response.data.error}`, {
						position: "top-right",
						autoClose: 1000,
						hideProgressBar: false,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "light",
					})
					setSuccessful(false);
				}
			},
		)

	}

	const handleContractView = (id,) => {
		navigate("/contract/view", { state: id })
	}

	useEffect(() => {
		if (ReceipttableRef.current) {
		  ReceipttableRef.current.onQueryChange();
		}
		}, [ReceipttableRef]);

	return (
		<>

			<div className="page-wrapper">
				<ToastContainer />
				<div className="content container-fluid">
					{
						loading === false ? (
							<>
								<div className="row">
									<div className="col-md-12">
										<div className="">
											<div className="body">
												<div className="table-responsive">
													<MaterialTable
														tableRef={ReceipttableRef}
														style={{
															backgroundColor: "var(--bs-table-bg)",
															borderBottomWidth: "1px",
															boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
														}}
														title={<h5 className="mb-0" >{t("Receipts")}</h5>}
														columns={[
															{
																title: `${t("Receipt No")}`,
																field: "receipt_number",
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																},
																render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Receipt No")}</div> <div className="hyperlink" onClick={() =>
																	permissionss && permissionsArray.includes('view_receipts') === true ?
																		handleView(rowData.id, rowData.status) : ""}>{(rowData.receipt_number)}</div></>,
															},


															{
																title: `${t("Contract Number")}`,
																field: "contract_id.contract_number",
																render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Contract Number")}</div> <div className="hyperlink" onClick={() =>
																	permissionss && permissionsArray.includes('view_contract') === true ? handleContractView(rowData.contract_id.id,) : ""}>{(rowData.contract_id ? rowData.contract_id.contract_number : "None")}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Customer Name")}`,
																field: "customer_id.customer_name",
																render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Customer Name")}</div> <div>{rowData.customer_id ? rowData.customer_id.customer_name : "None"}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Receipt Amount")}`,
																field: "receipt_amount",
																render: rowData => <> <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
																>{t("Receipt Amount")}</div>
																	<div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}> {Helper.Amount(rowData.receipt_amount)}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "right"
																},
																// cellStyle: {
																// 	textAlign: "right",
																// 	fontSize: 12
																// }
															},

															{
																title: `${t("Applied Amount")}`,
																field: "applied_amount",
																render: rowData => <> <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
																>{t("Applied Amount")}</div>
																	<div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(Math.abs(rowData.applied_amount))}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "right"
																},
																// cellStyle: {
																// 	textAlign: "right",
																// 	fontSize: 12
																// }
															},
															{
																title: `${t("Receipt Method")}`,
																field: "receipt_method",
																render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Receipt Method")}</div> <div>{rowData.receipt_method}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Receipt Date")}`,
																field: "receipt_date",
																render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Receipt Date")}</div> <div>{Helper.DateNormal(rowData.receipt_date)}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Receipt Status")}`,
																field: "status",
																render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Receipt Status")}</div> <div>{rowData.status}</div></>,
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															{
																title: `${t("Notes")}`,
																field: "",
																hidden: customerPermission !== 'Customer' ? false : true,
																render: (rowData) => (
																	<>
																		<div className="d-xl-none tc d-md-none d-lg-none">
																			{t("Notes")}
																		</div>
																		<div
																			className="cursor-pointer"
																			onClick={() => {
																				setIsSidePanelOpen(true);
																				setSelectedRowId(rowData.id);
																			}}
																		>
                                    <span className="cursor-pointer">
																			{rowData.has_notes ?
																				<img
																					src={
																						process.env.PUBLIC_URL +
																						"/static/assets/img/curved-images/icons8-sticky-notes-96.png"
																					}
																					alt="notes"
																					height='30px'
																					width='30px'
																				/> :
																				<><img
																						src={process.env.PUBLIC_URL +
																							"/static/images/iconplus.png"}
																						alt="notes"
																						height='22px'
																						width='22px' /></>
																			}
																			</span>
																		</div>
																		{isSidePanelOpen && selectedRowId === rowData.id && (
																			<NotesSingle
																				setIsSidePanelOpen={setIsSidePanelOpen}
																				isSidePanelOpen={isSidePanelOpen}
																				state={selectedRowId}
																				object_name={object_name}
																			/>
																		)}
																	</>
																),
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left",
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12,
																},
															},
															{
																title: "Apply",
																// field: "receipt_date",
																hidden: customerPermission === 'Customer',
																editable: false,
																// render: (rowData) => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Apply")}</div> <div>{rowData.applied_amount === rowData.receipt_amount ?
																render: (rowData) => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Apply")}</div> <div>{
																	rowData.status === "Fully Applied" ||
																		Number(rowData.applied_amount).toFixed(2) === Number(rowData.receipt_amount).toFixed(2)?
																	<button disabled style={{ color: "Red" }} className="btn bg-gradient-secondary btn-sm ms-auto mb-0" >Applied</button> :
																	rowData.status === "Unidentified Amount" ? "" : rowData.status === "Cancelled" ? "" :rowData.status === "Reversed" ? "":
																		<button style={{ color: "green" }} className="btn bg-gradient-secondary btn-sm ms-auto mb-0" onClick={() => handleApplyManually(rowData.id, rowData.receipt_amount, rowData.applied_amount, rowData.contract_id ? rowData.contract_id.id : null, rowData.customer_id ? rowData.customer_id.id : null)}>Apply</button>}</div></>,
																// onClick: (rowData) => rowData.applied_amount === rowData.receipt_amount? handleApplyManually(rowData.id,rowData.receipt_amount,rowData.contract_id.id) : "",
																headerStyle: {
																	verticalAlign: "inherit",
																	fontWeight: "bold",
																	textAlign: "left"
																},
																cellStyle: {
																	textAlign: "left",
																	fontSize: 12
																}
															},
															
														]}
														// data={items}
														data={query =>
															new Promise((resolve, reject) => {
																const { orderBy, orderDirection } = query;

																if (selectedValue2 && selectedValue) {
																	contractNumber = selectedValue2.contract_number;
																	customerName = selectedValue.customer_name;
																}
																else if (selectedValue2) {
																	contractNumber = selectedValue2.contract_number;
																}
																else if (selectedValue) {
																	customerName = selectedValue.customer_name;
																}
																let url = API + "receipts/view/receipts/?"
																url += `status=${receiptstatus !== null ? receiptstatus : ""}`
																url += '&per_page=' + query.pageSize
																url += '&page=' + (query.page + 1)
																url += '&search=' + query.search
																url += `&contractNumber=${contractNumber !== "" ? contractNumber : ""}`
																url += `&customerName=${customerName !== "" ? customerName : ""}`
																if (orderBy) {
																	url += `&orderBy=${orderBy.field}`;
																	url += `&orderDirection=${orderDirection}`;
																}
																fetch(url, { headers: authHeader() })
																	.then(response => response.json())
																	.then(result => {
																		resolve({
																			data: query.orderBy && query.orderDirection
																				? _.orderBy(
																					result.data,
																					[query.orderBy.field],
																					[query.orderDirection]
																				)
																				: result.data,
																			page: result.page - 1,
																			totalCount: result.total,
																		})
																	})
															})
														}
														components={{
															Toolbar: props => (
																<div className='MuiToolbar-root MTableToolbar-spacer-21  my-temp-class'>
																	<MTableToolbar {...props} />
																	<span onClick={() => setState({ isPaneOpen: true })} style={{ color: "#b4b7c5", paddingRight: "1px", cursor: "pointer" }}>
																		<img src={process.env.PUBLIC_URL + '/static/images/ic-filter.svg'}
																			alt="" />
																	</span>
																	{
																		permissionss && permissionsArray.includes('add_receipts') === true ?
																			customerPermission !== 'Customer' &&
																			<Link className="navbar-brand m-0" to="/receipts/createreceipts">
																				<button className="add-part btn btn-primary  mb-0" id="add-task" >+&nbsp; {t('New Receipt')}</button>
																			</Link>
																			: ""
																	}
																</div>
															)
														}}
														options={{
															headerStyle: {
																backgroundColor: "white",
																color: "#245C7F",
																fontSize: 10,
															},
															rowStyle: (rowData, index) => {
																if (index % 2) {
																	return { backgroundColor: "#fff" }
																}
															},
															sorting: true,
															search: true,
															toolbar: true,
															paging: true,
															pageSize: 10,       // make initial page size
															emptyRowsWhenPaging: false,   // To avoid of having empty rows
															pageSizeOptions: [10, 25, 30, 50],
															paginationType: "stepped",
															showFirstLastPageButtons: false,
															actionsColumnIndex: -1,
														}}
													/>
												</div>
											</div>
										</div>
										<SlidingPane
											className="some-custom-class"
											overlayClassName="some-custom-overlay-class"
											isOpen={state1.isPaneOpen}
											title="Filter By"
											subtitle=""
											onRequestClose={() => {
												// triggered on "<" on left top click or on outside click
												setState({ isPaneOpen: false });
											}}
										>
											<div className="row">
												<div className="col-xl-12">
													<div className="form-group row">
														<label className="col-lg-12 col-form-label">{t("Customer Name")}</label>
														<div className="col-lg-12">
															<AsyncSelect
																defaultOptions
																isClearable
																value={selectedValue}
																placeholder={t("Search for Customer(%for All)")}
																getOptionLabel={e => e.customer_name}
																getOptionValue={e => e.customer_name}
																loadOptions={loadOptions}
																onInputChange={handelInputChange}
																onChange={handelChange}
															>
															</AsyncSelect>
														</div>
													</div>
												</div>
												<div className="col-xl-12">
													<div className="form-group row">
														<label className="col-lg-12 col-form-label">{t("Contract Number")}</label>
														<div className="col-lg-12">
															<AsyncSelect
																defaultOptions
																isClearable
																value={selectedValue2}
																placeholder={t("Search for Contract(%for All)")}
																getOptionLabel={e => e.contract_number}
																getOptionValue={e => e.contract_number}
																loadOptions={loadOptions2}
																onInputChange={handelInputChange2}
																onChange={handelChange2}
															>
															</AsyncSelect>
														</div>
														<input type="hidden" id="contract_status" value='' />
													</div>
												</div>
												<div className="col-xl-12">
													<div className="form-group row">
														<div className="col-lg-12 text-left" style={{ marginTop: "30px" }}>
															<button type="button" className="clearReceipt btn bg-gradient-secondary ms-auto mb-0" onClick={handleClear}>{t("RESET")}</button>&nbsp;&nbsp;
															<button type="button" className="filterReceipt btn btn-primary ms-auto mb-0" onClick={() => Helper.handleSearch(ReceipttableRef)}>{t("Apply")}</button>&nbsp;&nbsp;
														</div>
													</div>
												</div>
											</div>
										</SlidingPane>
									</div>
								</div>

							</>
						) : (
							<ContentLoader
								viewBox="0 0 1000 550"
								backgroundColor="rgba(0,0,0,0.06)"
								foregroundColor="rgba(0,0,0,0.12)"
							>
								<rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
								<circle cx="879" cy="123" r="11" />
								<circle cx="914" cy="123" r="11" />
								<rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
								<rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
								<rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
								<rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
								<circle cx="880" cy="184" r="11" />
								<circle cx="915" cy="184" r="11" />
								<rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
								<rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
								<rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
								<rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
								<circle cx="881" cy="242" r="11" />
								<circle cx="916" cy="242" r="11" />
								<rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
								<rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
								<rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
								<rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
								<circle cx="882" cy="303" r="11" />
								<circle cx="917" cy="303" r="11" />
								<rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
								<rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
								<rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
								<rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
								<circle cx="881" cy="363" r="11" />
								<circle cx="916" cy="363" r="11" />
								<rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
								<rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
								<rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
								<rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
								<circle cx="882" cy="424" r="11" />
								<circle cx="917" cy="424" r="11" />
								<rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
								<rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
								<rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
								<rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
								<rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
								<rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
								<circle cx="882" cy="484" r="11" />
								<circle cx="917" cy="484" r="11" />
								<rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
								<rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
								<rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
								<rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
								<rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
								<rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
								<rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
								<rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
								<rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
								<rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
							</ContentLoader>
						)
					}
				</div>
			</div>
			<div className="modal right fade" id="receipt_details" role="dialog" aria-modal="true">
			</div>
		</>
	)
}

export default ViewRecipts
